import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MessageCircle } from "lucide-react";
import { AccessibilityWidget } from "../common/AccessibilityWidget";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { t } = useTranslation('common');
  
  return (
    <div className="min-h-screen flex flex-col font-body">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/972528300088?text=${encodeURIComponent(t('whatsappMessage'))}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed z-50 w-12 h-12 md:w-14 md:h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 animate-pulse-glow"
        style={{ 
          bottom: 'max(env(safe-area-inset-bottom, 0px) + 16px, 24px)',
          left: '16px'
        }}
        aria-label={t('buttons.whatsapp')}
      >
        <MessageCircle className="w-6 h-6 md:w-7 md:h-7 text-primary-foreground" />
      </a>
      
      {/* Accessibility Widget */}
      <AccessibilityWidget />
    </div>
  );
}
